<template>
  <div>
    <span
      v-if="!isAuthorized && type !== 'hidden'"
      class="d-print-none"
    >
      <slot
        name="message"
      >
        <div
          v-if="type === 'component'"
          class="d-flex align-center grey--text caption"
        >
          <v-icon
            small
            color="grey lighten-1"
            class="mr-1"
          >
            mdi-lock
          </v-icon>
          <span>{{ unauthorizedGuardMessage }}</span>
        </div>
        <div
          v-else
          class="text-center mt-12"
        >
          <v-icon
            large
            color="grey lighten-1"
          >
            mdi-lock-outline
          </v-icon>
          <h1 class="text-h6 mt-2">
            {{ unauthorizedGuardMessage }}
          </h1>
          <p class="body-2 grey--text mt-1">
            You don't have permission to view this page.
          </p>
          <v-sheet
            class="mx-auto mt-4 pa-3 text-left"
            max-width="400"
            outlined
            rounded
          >
            <template v-if="canList.length">
              <div
                v-for="perm in missingPermissions"
                :key="perm"
                class="caption grey--text"
              >
                <span class="font-weight-medium">Missing permission:</span>
                <code class="ml-1">{{ perm }}</code>
              </div>
            </template>
            <template v-else>
              <div
                v-if="$route.meta && $route.meta.permission"
                class="caption grey--text"
              >
                <span class="font-weight-medium">Required permission:</span>
                <code class="ml-1">{{ $route.meta.permission }}</code>
              </div>
              <div class="caption grey--text mt-1">
                <span class="font-weight-medium">Page:</span>
                <span class="ml-1">{{ $route.name }}</span>
              </div>
              <div class="caption grey--text mt-1">
                <span class="font-weight-medium">Path:</span>
                <span class="ml-1">{{ $route.fullPath }}</span>
              </div>
            </template>
          </v-sheet>
          <p class="caption grey--text mt-3">
            Contact your administrator to request access.
          </p>
          <v-btn
            small
            class="mt-1"
            @click="() => $router.back()"
          >
            Go Back
          </v-btn>
        </div>
      </slot>
    </span>
    <slot v-if="isAuthorized" />
  </div>
</template>

<script>
export default {
  name: 'UnauthorizedMessage',
  props: {
    authorized: { type: Boolean, required: false, default: false },
    can: { type: String, required: false, default: '' },
    route: { type: Boolean, required: false, default: false },
    type: { type: String, required: false, default: 'page' },
    message: { type: String, required: false, default: null }
  },
  computed: {
    canList () {
      return this.can ? this.can.split(',').map(p => p.trim()).filter(Boolean) : []
    },
    isAuthorized () {
      if (this.route) {
        const permission = this.$route.meta?.permission
        return permission ? this.$store.getters.can(permission) : true
      }
      if (this.canList.length) {
        return this.canList.every(p => this.$store.getters.can(p))
      }
      return this.authorized
    },
    missingPermissions () {
      return this.canList.filter(p => !this.$store.getters.can(p))
    },
    unauthorizedGuardMessage () {
      if (this.message) {
        return this.message
      }
      if (this.missingPermissions.length) {
        return `requires '${this.missingPermissions.join("', '")}'`
      }
      return 'Not Available'
    }
  }
}
</script>
